import { createFileRoute } from '@tanstack/react-router';
import { InstructorCourseListPage } from '@pages/instructor';

/**
 * Instructor Course Management List
 *
 * Route: /:locale/instructor/courses
 * List of courses the instructor is managing
 */
export const Route = createFileRoute('/$locale/_authenticated/instructor/courses/')({
  component: InstructorCourseList,
});

function InstructorCourseList() {
  const { locale } = Route.useParams();
  return <InstructorCourseListPage locale={locale} />;
}
